import { Pagination } from 'antd';
import type { DataTablePaginationConfig } from './types';

export default function DataTablePagination({
  page,
  pageSize,
  total,
  pageSizeOptions = [10, 20, 50, 100],
  onChange,
}: DataTablePaginationConfig) {
  if (total === 0) return null;
  return (
    <div className="flex justify-end">
      <Pagination
        current={page}
        pageSize={pageSize}
        total={total}
        showSizeChanger
        showQuickJumper
        pageSizeOptions={pageSizeOptions}
        showTotal={(t, range) => `Showing ${range[0]}–${range[1]} of ${t}`}
        onChange={(p, ps) => onChange(p, ps)}
      />
    </div>
  );
}
